/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#certFlex p-tabview{display:flex;flex:1 1 auto}#certFlex p-tabview .ui-tabview-panels{flex:1 1 auto;flex-flow:column;padding:0 0 0 5px}#certFlex p-tabview .ui-tabview-panels p-tabpanel{height:100%}#certFlex p-tabview .ui-tabview-panels p-tabpanel .ui-tabview-panel:not(.ui-helper-hidden){height:100%;position:relative}#certFlex p-tabview .ui-tabview-panels p-tabpanel .ui-tabview-panel:not(.ui-helper-hidden) p-scrollpanel .ui-scrollpanel{position:absolute;top:0;bottom:0;left:0;right:0;border:none}"];
export { styles as styles };
